exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".nav_btm[data-v-428eef32]{position:fixed;bottom:0;width:100%;height:50px;background:#fff;border-top:1px solid #d4d2d3}.nav_btm ul li[data-v-428eef32]{float:left;width:20%;text-align:center;overflow:hidden}.nav_btm ul li img[data-v-428eef32]{width:60px}", "", {"version":3,"sources":["D:/qianduan/ahjgjtMobile/src/components/common/navBottom.vue"],"names":[],"mappings":"AACA,0BAA0B,eAAgB,SAAS,WAAW,YAAY,gBAAgB,4BAA6B,CACtH,AACD,gCAAgC,WAAY,UAAU,kBAAmB,eAAiB,CACzF,AACD,oCAAoC,UAAW,CAC9C","file":"navBottom.vue","sourcesContent":["\n.nav_btm[data-v-428eef32]{position: fixed;bottom:0;width:100%;height:50px;background:#fff;border-top:1px solid #D4D2D3;\n}\n.nav_btm ul li[data-v-428eef32]{float: left;width:20%;text-align: center;overflow: hidden;\n}\n.nav_btm ul li img[data-v-428eef32]{width:60px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-428eef32","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/navBottom.vue
// module id = 366
// module chunks = 3 4 6 11 12 13 22